import React from "react";

type Option = {
  label: string;
  value: number;
};

type OptionSetProps = {
  options: Option[];
  value: number;
  onChange: (value: number) => void;
  name?: string; // to group radios correctly
};

export const OptionSet: React.FC<OptionSetProps> = ({ options, value, onChange, name = "option-set" }) => {
  return (
    <div className="flex flex-col">
      {options.map((option) => (
        <label key={option.value} className="flex items-center gap-1 cursor-pointer m-0">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            className="accent-sky-600 dark:accent-orange-400"
          />
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </div>
  );
};
